import { platformBrowserDynamic } from "@angular/platform-browser-dynamic"
import { enableProdMode } from "@angular/core"

import { AppEnv } from "./app.env"
import { AppModule } from "./app.module"

if (!AppEnv.isDev)
  enableProdMode()

platformBrowserDynamic().bootstrapModule(AppModule)



// WEBPACK FOOTER //
// ./src/app/main.ts